<template>
  <span
    class="inline-flex max-w-full items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-medium shadow-sm"
    :class="
      locked
        ? 'border-theme-border/70 bg-theme-bg-subtle text-theme-text-muted opacity-70 dark:bg-theme-surface'
        : 'border-theme-border bg-theme-surface text-theme-text dark:border-theme-border dark:bg-theme-surface-raised'
    "
    :title="locked ? t('subscription_entitlements.not_included') : grantKey"
    :data-grant-key="grantKey"
    :data-locked="locked ? 'true' : 'false'"
  >
    <icon
      :path="locked ? mdiLockOutline : display.icon"
      size="16"
      class="shrink-0"
      :class="locked ? 'text-theme-danger' : 'text-theme-palette-emerald dark:text-theme-palette-emerald'"
    />
    <span class="truncate font-semibold">{{ display.entityLabel }}</span>
    <span
      v-if="showAction"
      class="shrink-0 rounded-full bg-theme-bg-subtle px-2 py-0.5 text-[10px] font-semibold text-theme-text-secondary dark:bg-theme-surface"
    >
      {{ display.actionLabel }}
    </span>
  </span>
</template>

<script setup>
  import Icon from '@/components/Icon';
  import { grantDisplayFor } from '@/utils/grantDisplay';
  import { mdiLockOutline } from '@mdi/js';
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  defineOptions({ name: 'GrantDisplayChip' });

  const props = defineProps({
    grantKey: { type: String, required: true },
    showAction: { type: Boolean, default: true },
    /** Render as a locked/disabled chip with a red lock (entitlement not owned). */
    locked: { type: Boolean, default: false },
  });

  const { t } = useI18n();
  const display = computed(() => grantDisplayFor(props.grantKey, t));
</script>
